/*
 * @author Maciej Sikora
 * @copyright BossByte Web Application
 */


app.controller('MessageReportDetails', function($scope, _$privileges, _$breadcrumbs, report, states, types, ends, connected,
    toConnectReports, _$report, _$user, _$toast, _$editmode, $rootScope, $mdDialog) {

    //array of possible states
    //it depends on state of workflow
    
    $scope.possibleStates = {

        1: [states[0], states[1]],
        2: [states[1], states[2], states[4], states[3]],
        3: [states[2]], //only reborn
        4: [states[3]],
        5: [states[4], states[2], states[3], states[5]]

    };

    //reports to which we can connect
    var toConnectReports = toConnectReports.data.reports.filter(function(el) {

        //not the same as we currently are
        return el.id !== report.id;

    });

    //add to breadcrumb
    _$breadcrumbs.push(report.title);

    $scope.editable = false;

    $scope.canedit = _$privileges.write("report");

    $scope.ends = ends;

    //connected reports list
    $scope.connected = connected.data.connected;
    $scope._ = _; //lodash
    $scope.types = types;

    $scope.adopted = report.report_state_id !== 1; //if first state then we can adopt it, else it was adopted

    //if report is connected as children to different one
    $scope.isConnected = !_.isNull(report.connected_report_id);

    //trybe edycji wylaczony
    _$editmode.turnOff();

    $scope.forwardStateId;

    function assignReport(rep) {

        $scope.report = rep;

        $scope.report.end_date = new Date($scope.report.end_date);


    };


    function statesSelectInit() {

        $scope.states = $scope.possibleStates[$scope.report.report_state_id];

        //check if state is one of can be resumed
        if ($scope.report.report_state_id === 6 || $scope.report.report_state_id === 4 || $scope.report.report_state_id === 3)
            $scope.canBeResume = true;
        else
            $scope.canBeResume = false;
    }

    //refreshesh report data
    function refreshReport() {

        _$report.getSingle($scope.report.id).then(function(result) {

            assignReport(result);
            $scope.report.comment = ""; //clean comment


            //refresh possible states
            statesSelectInit();
        });

    };


    assignReport(report);
    //set only possible states to select
    statesSelectInit();

    $scope.connect = function() {

        if (toConnectReports.length === 0) {

            //no reports to connect
            _$toast.message("Nie istnieje żadne aktualne zgłoszenie do którego możemy połączyć obecnie wybrane.");
            return;
        }

        _$report.showConnectDialog(toConnectReports)
            .then(function(toConnectId) {

                if (toConnectId === $scope.report.id) {

                    _$toast.message("Proszę wybrać inne zgłoszenie do połączenia");
                    return;
                }

                _$report.connect(toConnectId, [{
                    id: $scope.report.id
                }]).then(function() {

                    _$toast.success("Zgłoszenie zostało połączone pod inne");
                    $scope.isConnected = true; //is connected
                    $scope.report.parent_connect = toConnectReports.find(function(r) {

                        //set connected object
                        return r.id === toConnectId;

                    });

                });

            });

    };

    $scope.unConnect = function() {

        console.log("DZIALA!");
        _$report.unConnect($scope.report.id).then(function() {

            _$toast.success("Zgłoszenie zostało odłączone");
            $scope.isConnected = false; //is not connected
        });

    };

    $scope.activate = function() {

        if (!$scope.canedit)
            return;

        _$report.activate(report.id).then(function() {

            _$toast.success("Wznowiono zgłoszenie");
            $scope.report.active = true;

        });
    };

    $scope.deactivate = function() {

        if (!$scope.canedit)
            return;

        _$report.deactivate(report.id).then(function() {

            _$toast.error("Zablokowano zgłoszenie");
            $scope.report.active = false;
        });
    };

    //adopt this report on current logged user
    $scope.adopt = function() {

        if (!$scope.canedit)
            return;

        _$report.adopt(report.id).then(function() {

            _$toast.success("Przyjęto zgłoszenie");
            $scope.adopted = true;
            refreshReport();
            statesSelectInit();
        });

    };


    //resume of report
    $scope.resume = function() {

        if (!$scope.canedit)
            return;

        _$report.resume(report.id).then(function() {

            _$toast.success("Wznowiono zgłoszenie");
            refreshReport();
            statesSelectInit();
        });
    };

    $scope.editToggle = function() {

        if (!$scope.canedit)
            return;

        $scope.editable = !$scope.editable;
        $scope.tab.selected = 1;

        if ($scope.editable) {
            _$toast.message("Przejście w tryb edycji");
            _$editmode.turnOn();
        } else {
            _$toast.message("Wyjście z trybu edycji");

            _$editmode.turnOff();
        }
    };

    $scope.editCancel = function() {

        $scope.editToggle();
        refreshReport();
    };



    $scope.beforeSave = function(form) {
        if (form) {
            if (form.$valid) {
                return true;
            } else {
                angular.forEach(form.$error, function(field) {
                    angular.forEach(field, function(f) {
                        f.$setDirty();
                        f.$setTouched();
                    });
                });

                $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            }
        }
    };

    $scope.save = function(form) {

        if (!$scope.canedit)
            return;

        if (!$scope.beforeSave(form))
            return;

        //format date
        var toSend = angular.copy($scope.report);

        if (form.$name == "reportFormHandling") {
            delete toSend.title;
        } else {
            delete toSend.report_state_id;
        }

        toSend.end_date = moment($scope.report.end_date).format("YYYY-MM-DD");

        _$report.save(toSend, $scope.report.id).then(function() {

            _$toast.success("Zmiany w zgłoszeniu zapisane");
            $scope.editToggle();

            //refresh
            refreshReport();
            statesSelectInit();

        });

    };

    $scope.removeStatusButtonCheck = 0;
    $scope.removeStatusButton = function(comment) {
        if ($scope.editable && comment.state.symbol != 'edit' && ($scope.removeStatusButtonCheck == 0 || $scope.removeStatusButtonCheck == comment.id)) {
            $scope.removeStatusButtonCheck = comment.id;
            return true;
        } else {
            return false;
        }
    };

    var promise = _$report.getForwardState();
    promise.then(function(payload) {
        $scope.forwardStateId = payload.data;
    });

    $scope.removeImage = function() {
        var promise = _$report.removeImage($scope.report.id);
        promise.then(function(payload) {
            if (payload.data) {
                $scope.report.image = "";
                $rootScope.notification.show('success', 'Obrazek został usunięty');
                refreshReport();
                statesSelectInit();
            }
        });
    };

    $scope.rollbackState = function(id) {
        var promise = _$report.rollbackState(id);
        promise.then(function(payload) {
            if (payload.data) {
                refreshReport();
                statesSelectInit();
            }
        });
    };

    $scope.updateComment = function(comment) {
        var promise = _$report.updateComment(comment);
        promise.then(function(payload) {
            if (payload.data != "") {
                comment.user = payload.data;
            }
        });
    };

    $scope.showBackupContent = function(report) {
        console.log(report);
        $mdDialog.show({
            'templateUrl': '/assets/js/angular/message/views/partial/report/backup_content_dialog.html',
            'controller': function($mdDialog) {
                this.data = report.backup[0];
                this.hide = function() {
                    $mdDialog.hide();
                };
            },
            controllerAs: 'modal',
            clickOutsideToClose: true
        });

    };
});
